import React from 'react'
import SignUpForm from './form'
import { useNavigate } from 'react-router-dom'
import { AppDispatch, useAppDispatch } from '../../redux/store'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { registerUser } from '../../redux/reducers/userReducer'
import { validatePassword } from '../../helpers/utils'

/**SignUp is a view where the user sign up into the app*/
interface FormValues {
  name: string
  email: string
  password: string
}
const SignUp = ({}: FormValues) => {
  const dispatch: AppDispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const principalView = '/login'

  const handleSubmit = async (values: FormValues) => {
    if (!validatePassword(values.password)) {
      toast(t('PASSWORD_RULE'))
      return
    }

    try {
      const { payload } = await dispatch(
        registerUser({
          name: values.name,
          email: values.email,
          password: values.password,
        })
      )

      if (payload && payload.success) {
        const userEmail = payload.data.email
        navigate(`${principalView}?email=${userEmail}`)
      } else {
        toast(t('ERROR'))
      }
    } catch (error: any) {
      console.error('Error:', error)
    }
  }

  return (
    <div className='container-home width-100 d-flex'>
      <SignUpForm onSubmit={handleSubmit} name={''} email={''} password={''} />
    </div>
  )
}

export default SignUp
